import { render, staticRenderFns } from "./ChoosePlanItem.vue?vue&type=template&id=6e4bb4f8&scoped=true&"
import script from "./ChoosePlanItem.vue?vue&type=script&lang=js&"
export * from "./ChoosePlanItem.vue?vue&type=script&lang=js&"
import style0 from "./ChoosePlanItem.vue?vue&type=style&index=0&id=6e4bb4f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4bb4f8",
  null
  
)

export default component.exports